<template>
	<div v-if="allowOrderNotes" class="cart-instructions-wrapper">
		<label class="cart-instructions-label" for="cart-instructions">{{ label }}</label>
		<textarea
			id="cart-instructions"
			name="cart-instructions"
			:class="[{ specialInstructionsApplied: specialInstructionsApplied }, 'cart-instructions']"
			cols="30"
			rows="1"
			:placeholder="placeholder"
			v-model="specialInstructionsValue"
			@click="specialInstructionsApplied = false"
			@keyup.enter="updateRestComment()"
			@blur="updateRestComment()"
			v-on:input="$emit('input', $event.target.value)"
		></textarea>
	</div>
	<div v-else class="cart-instructions-wrapper">
		<label class="cart-instructions-label" for="cart-instructions">{{ disabledLabel }}</label>
		<textarea
			disabled
			id="cart-instructions"
			name="cart-instructions"
			class="cart-instructions area-disabled"
			cols="30"
			rows="1"
		></textarea>
	</div>
</template>

<script>
const debounce = require("lodash/debounce");

export default {
	name: "CartInstructions",
	props: {
		// value: {
		// 	type: String
		// },
		specialInstructions: {
			type: String,
		},
		restId: {
			type: String,
		},
		label: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		disabledLabel: {
			type: String,
		},
		allowOrderNotes: {
			type: Boolean,
		},
	},
	data: function () {
		return {
			specialInstructionsValue: this.specialInstructions ? this.specialInstructions : "",
			specialInstructionsApplied: this.specialInstructions ? true : false,
		};
	},
	methods: {
		updateRestComment: debounce(
			function () {
				this.$emit("updateRestComment", { restId: this.restId, comment: this.specialInstructionsValue });
				this.specialInstructionsApplied = true;
			},
			500,
			{ leading: true, trailing: false }
		),
	},
};
</script>

<style lang="scss" scoped>
.cart-instructions-wrapper {
	position: relative;
	margin-bottom: 10px;
}

.cart-instructions-label {
	font-size: 1.2rem;
	font-weight: 700;
}

.cart-instructions {
	border: 1px solid;
	border-radius: 2px;
	height: 55px;
	width: 100%;
	font-size: 1.6rem;
	resize: none;

	&::placeholder {
		color: $placeholder_color;
	}
	&:focus {
		outline-color: $tomato;
		outline-style: auto;
		outline-offset: 0px;
		outline-width: 1px;
	}
}

.specialInstructionsApplied {
	background-color: #f3f3f3;
}
.area-disabled {
	background-color: #f3f3f3;
	&:hover {
		cursor: not-allowed;
	}
}
</style>